import { useState } from "react";
import type { Project } from "@/features/leaderboard/types/index.ts";
import type { IntelligenceMode } from "../types/index.ts";
import { BackerLeagueTable } from "./BackerLeagueTable.tsx";
import { BackerSpecializationMatrix } from "./BackerSpecializationMatrix.tsx";
import { CategoryFamilyMatrix } from "./CategoryFamilyMatrix.tsx";
import { CoInvestorFinder } from "./CoInvestorFinder.tsx";
import { EcosystemSnapshot } from "./EcosystemSnapshot.tsx";
import { FounderPedigreeConcentrationView } from "./FounderPedigreeConcentration.tsx";
import { KpiStrip } from "./KpiStrip.tsx";
import { RunwayStressList } from "./RunwayStressList.tsx";
import { ScoreFundingScatter } from "./ScoreFundingScatter.tsx";
import { StageMix } from "./StageMix.tsx";
import { StealthWatchlist } from "./StealthWatchlist.tsx";

interface IntelligenceViewProps {
  onOpenProjectDetail?: (project: Project) => void;
}

export function IntelligenceView({ onOpenProjectDetail }: IntelligenceViewProps = {}) {
  const [mode, setMode] = useState<IntelligenceMode>("operator");

  return (
    <div className={`intel-view intel-view--${mode}`}>
      <div className="intel-view__header">
        <div>
          <h2 className="intel-view__title">Intelligence</h2>
          <p className="intel-view__subtitle">
            Proprietary research on the pre-TGE crypto market. Admin-only.
          </p>
        </div>
        <ModeToggle mode={mode} onChange={setMode} />
      </div>

      <KpiStrip />
      <CategoryFamilyMatrix />
      <ScoreFundingScatter onOpenProjectDetail={onOpenProjectDetail} />
      <BackerLeagueTable />
      <BackerSpecializationMatrix />
      <CoInvestorFinder onOpenProjectDetail={onOpenProjectDetail} />
      <RunwayStressList onOpenProjectDetail={onOpenProjectDetail} />
      <StealthWatchlist onOpenProjectDetail={onOpenProjectDetail} />
      <FounderPedigreeConcentrationView />
      <EcosystemSnapshot />
      <StageMix />
    </div>
  );
}

function ModeToggle({
  mode,
  onChange,
}: {
  mode: IntelligenceMode;
  onChange: (m: IntelligenceMode) => void;
}) {
  return (
    <div className="intel-mode-toggle" role="tablist" aria-label="View mode">
      <button
        type="button"
        role="tab"
        aria-selected={mode === "operator"}
        className={`intel-mode-toggle__btn${mode === "operator" ? " active" : ""}`}
        onClick={() => onChange("operator")}
      >
        Operator
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={mode === "report"}
        className={`intel-mode-toggle__btn${mode === "report" ? " active" : ""}`}
        onClick={() => onChange("report")}
      >
        Report
      </button>
    </div>
  );
}
